module.exports = __webpack_public_path__ + "img/view_device_c1_one_en.e6a59e7a.png";